export default {
  "clock/flagged": {
    en: "Flag",
    fr: "Tombé",
  },
};
